/*@ngInject*/
const CollapsibleLeftNavController = function ($rootScope, $element, coreConstant) {

    this.$onInit = function () {
        $element.addClass('collapsibleLeftNav');

        this.isDrawerOpen = true;
        $element.addClass('open');
    };

    this.onToggleDrawer = function () {
        if (this.collapsible) {
            this.isDrawerOpen = !this.isDrawerOpen;

            if (this.isDrawerOpen) {
                $element.addClass('open');
                $rootScope.$broadcast(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED);
            } else {
                $element.removeClass('open');
                $rootScope.$broadcast(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED);
            }
        }
    };
};

angular.module('umCore')
    .controller('collapsibleLeftNavController', CollapsibleLeftNavController);
